import React, { useEffect, useState } from "react";
import PackService from "../../../services/PackService";

//CSS
import "../../../utils/Css/Marketing.css";
import "../../../utils/Css/Campagne.css";

//Link
import { Link } from "react-router-dom";

function formatReadableDate(rawDate) {
  if (!rawDate) return "Invalid date";

  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  };

  return new Date(rawDate).toLocaleDateString('fr-FR', options);
}


function PackDetails() {
  const [pack, setPack] = useState({})
  const [productPacks, setProductPacks] = useState([])

  useEffect(() => {
    const fetchDetails = async () => {
      const packId = localStorage.getItem("packId");
      if (packId) {
        try {
          const response = await PackService.packDetails(packId);
          setPack(response.data.success)
          setProductPacks(response.data.success.productPacks)
          console.log("Response:", response); // Log the response here
        } catch (error) {
          console.error("Error fetching pack details:", error);
        }
      }
    };

    fetchDetails();
  }, []);

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <br />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            {pack?.namePack && (
              <div className="col-lg-3 col-6">
                <div className="info-box mb-3 bg-gray">
                  <span className="info-box-icon">
                    <i class="fas fa-solid fa-box icon-campagne mr-3"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Nom du pack</span>
                    <span className="info-box-number">{pack?.namePack}</span>
                  </div>
                </div>
              </div>
            )}
            <div className="col-lg-3 col-6">
              <div className="info-box mb-3 bg-gray">
                <span className="info-box-icon">
                  <i className="fas fa-tag icon-campagne mr-3"></i>
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Référence</span>
                  <span className="info-box-number">{pack?.refPack}</span>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="info-box mb-3 bg-gray">
                <span className="info-box-icon">
                  <i className="fas fa-warehouse"></i> {/* Using warehouse icon */}
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Entrepôt</span> {/* More formal term */}
                  <span className="info-box-number">{pack?.warehouseName}</span>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="info-box mb-3 bg-gray">
                <span className="info-box-icon">
                  <i className="fas fa-money-bill"></i> {/* Better icon for "Prix" */}
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Prix</span>
                  <span className="info-box-number">{pack?.price}</span>
                </div>
              </div>
            </div>

          </div>
          <div className="row">
            <div className="col-lg-3 col-6">
              <div className="info-box mb-3 bg-gray">
                <span className="info-box-icon">
                  <i className="fas fa-calendar-alt icon-campagne mr-3"></i> {/* Calendar icon */}
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Date de création</span>
                  <span className="info-box-number">{formatReadableDate(pack?.creationDate)}</span>
                </div>
              </div>
            </div>

            {pack?.dateDebut &&
              <div className="col-lg-3 col-6">
                <div className="info-box mb-3 bg-gray">
                  <span className="info-box-icon">
                    <i className="fas fa-calendar-alt icon-campagne mr-3"></i> {/* Calendar icon */}
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Date de début</span>
                    <span className="info-box-number">{formatReadableDate(pack?.dateDebut)}</span>
                  </div>
                </div>
              </div>}
            {pack?.dateFin &&
              <div className="col-lg-3 col-6">
                <div className="info-box mb-3 bg-gray">
                  <span className="info-box-icon">
                    <i className="fas fa-calendar-alt icon-campagne mr-3"></i> {/* Calendar icon */}
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Date de Fin</span>
                    <span className="info-box-number">{formatReadableDate(pack?.dateFin)}</span>
                  </div>
                </div>
              </div>}
          </div>
        </div>
      </section>
      {/* Product Info Section */}
      <section className="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h6 className="card-title">Les produits</h6>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="collapse"
                      title="Collapse"
                    >
                      <i className="fas fa-minus"></i>
                    </button>
                  </div>
                </div>
                <div className="card-body p-0">
                  <table
                    className="table table-striped table-bordered table-sm"
                    cellSpacing="0"
                    width="100%"
                  >
                    <thead>
                      <tr className="text-center">
                        <th>Code du Produit</th>
                        <th>Code à Barres</th>
                        <th>Libellé</th>
                        <th>Quantité</th>
                      </tr>
                    </thead>
                    <tbody>
                      {productPacks.length > 0 ? (
                        productPacks.map((element, index) => (
                          <tr key={index} className="text-center">
                            <td>{element.product?.productCode || "N/A"}</td>
                            <td>{element.product?.barcode || "N/A"}</td>
                            <td>{element.product?.name || "N/A"}</td>
                            <td>{element.quantity || 0}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            Aucune donnée disponible
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PackDetails;
